// management/* 페이지 번역
const management = {
  factoryList: {
    label: {
      status: '상태',
    },
    status: {
      all: '전체',
      normal: '정상',
      warning: '경고',
      error: '이상',
    },
    searchPlaceholder: '공장명 또는 코드 검색',
    addBtn: '공장 추가',
    loading: '데이터를 불러오는 중...',
    col: {
      name: '공장명',
      code: '코드',
      location: '위치',
      temperature: '온도',
      humidity: '습도',
      equipmentStatus: '설비현황',
      operationRate: '가동률',
      status: '상태',
      lastInspection: '최종점검일',
      action: '작업',
    },
    manager: '담당: {manager}',
    equipmentTotal: '총 {total}대',
    equipmentRunning: '가동 {running}',
    equipmentIdle: '대기 {idle}',
    equipmentStopped: '정지 {stopped}',
    deleteModal: {
      title: '공장 삭제',
      message: '"{name}" 공장을 삭제하시겠습니까?\n이 작업은 되돌릴 수 없습니다.',
      confirm: '삭제',
      cancel: '취소',
    },
    alertDeleted: '"{name}" 공장이 삭제되었습니다.',
    alertDeleteFail: '공장 삭제에 실패했습니다.',
  },
  factoryRegister: {
    section: {
      basic: '기본 정보',
      manager: '담당자 정보',
    },
    label: {
      name: '공장명',
      code: '공장 코드',
      location: '위치',
      address: '상세 주소',
      managerName: '담당자명',
      contact: '연락처',
      email: '이메일',
      description: '비고',
    },
    placeholder: {
      name: '공장명 입력',
      code: '예: SEL-001',
      location: '예: 서울특별시 금천구',
      address: '상세 주소 입력',
      managerName: '담당자 이름 입력',
      contact: '010-0000-0000',
      email: 'example@company.com',
      description: '추가 설명 입력',
    },
    btn: {
      cancel: '취소',
      submit: '공장 등록',
    },
    alertSuccess: '공장이 성공적으로 등록되었습니다.',
    alertDuplicate: '이미 존재하는 공장 코드입니다. 다른 코드를 사용해주세요.',
    alertFail: '공장 등록에 실패했습니다. 입력 정보를 확인해주세요.',
  },
  factoryDetail: {
    title: '공장 상세 정보',
    loading: '데이터를 불러오는 중...',
    section: {
      basic: '기본 정보',
      manager: '담당자 정보',
      operation: '운영 정보',
      environment: '환경 정보',
    },
    label: {
      name: '공장명',
      code: '공장 코드',
      location: '위치',
      address: '상세 주소',
      managerName: '담당자명',
      contact: '연락처',
      email: '이메일',
      totalEquipment: '총 설비 수',
      running: '가동 중',
      idle: '대기',
      stopped: '정지',
      status: '상태',
      description: '비고',
      temperature: '현재 온도',
      humidity: '현재 습도',
      totalEquipmentShort: '총 설비',
      operationRate: '가동률',
      establishedDate: '설립일',
      lastInspection: '최종점검일',
    },
    status: {
      normal: '정상',
      warning: '경고',
      error: '이상',
    },
    unit: {
      count: '{n}대',
    },
    btn: {
      delete: '삭제',
      edit: '수정',
      cancel: '취소',
      save: '저장',
    },
    alertLoadFail: '공장 정보를 불러오는데 실패했습니다.',
    alertUpdateSuccess: '공장 정보가 성공적으로 수정되었습니다.',
    alertUpdateFail: '공장 정보 수정에 실패했습니다.',
    confirmDelete: '정말로 이 공장을 삭제하시겠습니까?\n삭제된 데이터는 복구할 수 없습니다.',
    alertDeleteSuccess: '공장이 성공적으로 삭제되었습니다.',
    alertDeleteFail: '공장 삭제에 실패했습니다.',
  },
  equipmentList: {
    loading: '데이터를 불러오는 중...',
    label: {
      factory: '공장',
      line: '라인',
      status: '상태',
    },
    statusOption: {
      all: '전체',
      running: '가동',
      idle: '대기',
      maintenance: '점검',
      fault: '고장',
    },
    status: {
      running: '가동',
      idle: '대기',
      stopped: '정지',
      maintenance: '점검',
      fault: '고장',
      offline: '오프라인',
    },
    searchPlaceholder: '설비명 또는 모델 검색',
    addBtn: '설비 추가',
    col: {
      name: '설비명',
      model: '모델',
      factory: '공장',
      line: '라인',
      manufacturer: '제조사',
      serialNumber: '시리얼넘버',
      status: '상태',
      maxTemperature: '최대온도',
      maxPressure: '최대압력',
      cycleTime: '사이클타임',
      cavity: '캐비티',
      lastInspection: '점검일',
      action: '작업',
    },
    deleteModal: {
      title: '설비 삭제',
      message: '"{name}" 설비를 삭제하시겠습니까?\n이 작업은 되돌릴 수 없습니다.',
      confirm: '삭제',
      cancel: '취소',
    },
    alertDeleted: '"{name}" 설비가 삭제되었습니다.',
    alertDeleteFail: '설비 삭제에 실패했습니다.',
  },
  equipmentRegister: {
    section: {
      basic: '기본 정보',
      spec: '사양 정보',
    },
    label: {
      equipmentCode: '설비 코드',
      equipmentName: '설비명',
      model: '모델',
      factory: '소속 공장',
      line: '라인',
      manufacturer: '제조사',
      serialNumber: '시리얼넘버',
      installDate: '설치일',
      warrantyEndDate: '보증 종료일',
      initialStatus: '초기 상태',
      maxTemperature: '최대 온도 (°C)',
      maxPressure: '최대 압력 (MPa)',
      ratedPower: '정격 전력 (kW)',
      targetCycleTime: '목표 사이클 타임 (초)',
      cavityCount: '캐비티 수',
      lastInspectionDate: '마지막 점검일',
      nextMaintenanceDate: '다음 정비일',
      description: '비고',
    },
    placeholder: {
      equipmentCode: '예: E001',
      equipmentName: '예: 사출기 #1',
      model: '예: LS-350H',
      factorySelect: '공장 선택',
      lineSelect: '라인 선택 (미지정)',
      manufacturer: '제조사명 입력',
      serialNumber: '설비 시리얼넘버 입력',
      maxTemperature: '예: 350',
      maxPressure: '예: 180',
      ratedPower: '예: 35.0',
      targetCycleTime: '예: 45',
      cavityCount: '예: 4',
      description: '추가 설명 입력',
    },
    statusOption: {
      running: '가동',
      idle: '대기',
      stopped: '정지',
      maintenance: '점검',
      fault: '고장',
      offline: '오프라인',
    },
    btn: {
      cancel: '취소',
      submit: '설비 등록',
    },
    alertSuccess: '설비가 성공적으로 등록되었습니다.',
    alertDuplicate: '이미 존재하는 설비 코드입니다. 다른 코드를 사용해주세요.',
    alertFail: '설비 등록에 실패했습니다. 입력 정보를 확인해주세요.',
  },
  equipmentDetail: {
    title: '설비 상세 정보',
    loading: '데이터를 불러오는 중...',
    section: {
      basic: '기본 정보',
      spec: '사양 정보',
    },
    label: {
      equipmentName: '설비명',
      equipmentCode: '설비 코드',
      model: '모델',
      factory: '소속 공장',
      line: '라인',
      manufacturer: '제조사',
      serialNumber: '시리얼넘버',
      installDate: '설치일',
      warrantyEndDate: '보증 종료일',
      status: '상태',
      maxTemperature: '최대 온도',
      maxPressure: '최대 압력',
      ratedPower: '정격 전력',
      targetCycleTime: '목표 사이클 타임',
      cavityCount: '캐비티 수',
      lastInspectionDate: '마지막 점검일',
      nextMaintenanceDate: '다음 정비일',
      description: '비고',
      cavity: '캐비티',
      targetCycle: '목표 사이클',
      lastInspection: '최종점검일',
    },
    placeholder: {
      lineSelect: '라인 미지정',
    },
    statusOption: {
      running: '가동',
      idle: '대기',
      stopped: '정지',
      maintenance: '점검',
      fault: '고장',
      offline: '오프라인',
    },
    btn: {
      delete: '삭제',
      edit: '수정',
      cancel: '취소',
      save: '저장',
    },
    alertLoadFail: '설비 정보를 불러오는데 실패했습니다.',
    alertUpdateSuccess: '설비 정보가 성공적으로 수정되었습니다.',
    alertUpdateFail: '설비 정보 수정에 실패했습니다.',
    confirmDelete: '정말로 이 설비를 삭제하시겠습니까?',
    alertDeleteSuccess: '설비가 성공적으로 삭제되었습니다.',
    alertDeleteFail: '설비 삭제에 실패했습니다.',
  },
  userList: {
    loading: '데이터를 불러오는 중...',
    label: {
      role: '역할',
    },
    roleOption: {
      all: '전체',
      systemAdmin: '시스템 관리자',
      normalUser: '일반 사용자',
    },
    role: {
      superAdmin: '슈퍼 관리자',
      systemAdmin: '시스템 관리자',
      normalUser: '일반 사용자',
    },
    status: {
      active: '활성',
      inactive: '비활성',
      locked: '잠김',
    },
    permissionLabel: {
      dashboard: '대시보드',
      monitoring: '모니터링',
      factory: '공장관리',
      equipment: '설비관리',
      user: '회원관리',
      role: '권한관리',
      system: '시스템관리',
    },
    searchPlaceholder: '이름 또는 이메일 검색',
    addBtn: '사용자 추가',
    col: {
      user: '사용자',
      position: '직위',
      department: '부서',
      status: '상태',
      lastLogin: '마지막 로그인',
      joinDate: '가입일',
      roleGroup: '권한 그룹',
      permissions: '권한 설정',
      action: '작업',
    },
    deleteModal: {
      title: '회원 삭제',
      message: '"{name}" 회원을 삭제하시겠습니까?\n이 작업은 되돌릴 수 없습니다.',
      confirm: '삭제',
      cancel: '취소',
    },
    alertDeleted: '"{name}" 회원이 삭제되었습니다.',
    alertDeleteFail: '회원 삭제에 실패했습니다.',
  },
  userRegister: {
    section: {
      basic: '기본 정보',
      organization: '조직 정보',
      permissions: '권한 설정',
    },
    label: {
      name: '이름',
      email: '이메일',
      password: '비밀번호',
      confirmPassword: '비밀번호 확인',
      phone: '전화번호',
      department: '부서',
      position: '직위',
      status: '계정 상태',
      roleGroup: '권한 그룹',
    },
    placeholder: {
      name: '사용자 이름 입력',
      email: 'example@company.com',
      password: '비밀번호 입력 (8자 이상)',
      confirmPassword: '비밀번호 재입력',
      phone: '010-0000-0000',
      department: '부서명 입력',
      position: '직위 입력',
    },
    statusOption: {
      active: '활성',
      inactive: '비활성',
    },
    permissionsNote: '(선택한 권한 그룹에 따라 자동 설정됨)',
    permissionsEmpty: '권한 그룹을 선택하면 권한 정보가 표시됩니다.',
    permissionCategoryEtc: '기타',
    btn: {
      cancel: '취소',
      submit: '사용자 등록',
    },
    alertPasswordMismatch: '비밀번호가 일치하지 않습니다.',
    alertSuccess: '사용자가 등록되었습니다.',
    alertFail: '사용자 등록에 실패했습니다. 다시 시도해주세요.',
    alertRoleGroupFail: '권한 그룹 목록을 불러오는데 실패했습니다.',
  },
  userDetail: {
    title: '사용자 상세 정보',
    loading: '데이터를 불러오는 중...',
    notFound: '사용자 정보를 찾을 수 없습니다.',
    section: {
      basic: '기본 정보',
      organization: '조직 정보',
      permissions: '권한 설정',
    },
    label: {
      name: '이름',
      email: '이메일',
      newPassword: '새 비밀번호',
      confirmPassword: '비밀번호 확인',
      phone: '전화번호',
      department: '부서',
      position: '직위',
      status: '계정 상태',
      roleGroup: '권한 그룹',
      joinDate: '가입일',
      lastLogin: '마지막 로그인',
    },
    placeholder: {
      newPassword: '변경할 경우에만 입력',
      confirmPassword: '비밀번호 재입력',
      phone: '010-1234-5678',
      department: '예: 경영지원팀',
      position: '예: 관리자',
    },
    statusOption: {
      active: '활성',
      inactive: '비활성',
      locked: '잠김',
    },
    status: {
      active: '활성',
      inactive: '비활성',
      locked: '잠김',
    },
    permissionsNote: ' (권한 그룹에 따라 자동 설정됨)',
    permissionsEmpty: '권한이 설정되지 않았습니다.',
    permissionCategoryEtc: '기타',
    btn: {
      delete: '삭제',
      edit: '수정',
      cancel: '취소',
      save: '저장',
    },
    alertPasswordMismatch: '비밀번호가 일치하지 않습니다.',
    alertLoadFail: '사용자 정보를 불러오는데 실패했습니다.',
    alertUpdateSuccess: '사용자 정보가 수정되었습니다.',
    alertUpdateFail: '사용자 정보 수정에 실패했습니다.',
    confirmDelete: '정말로 이 사용자를 삭제하시겠습니까?\n이 작업은 되돌릴 수 없습니다.',
    alertDeleteSuccess: '사용자가 삭제되었습니다.',
    alertDeleteFail: '사용자 삭제에 실패했습니다.',
  },
};

export default management;
